import { useEffect } from 'react';
import { toast } from 'sonner';

const KeyboardGiftEngine = () => {
  useEffect(() => {
    // Track which gifts have been shown this session
    const shownGifts = new Set(
      JSON.parse(sessionStorage.getItem('shownGifts') || '[]')
    );
    
    // Maximum 3 gifts per session
    const maxGifts = 3;

    const keywordActions = {
      'verify': {
        message: '🎁 Try Truth Gate — verify any claim for $5',
        link: '/oracle-brain',
        key: 'verify'
      },
      'check': {
        message: '🎁 Try Truth Gate — verify any claim for $5',
        link: '/oracle-brain',
        key: 'verify'
      },
      'buy': {
        message: '🎁 Access Tokens available — talk to any mind',
        link: '/tokens',
        key: 'buy'
      },
      'purchase': {
        message: '🎁 Access Tokens available — talk to any mind',
        link: '/tokens',
        key: 'buy'
      },
      'token': {
        message: '🎁 Access Tokens available — talk to any mind',
        link: '/tokens',
        key: 'buy'
      },
      'create': {
        message: '🎁 Meet Aria at NextXus Studio',
        link: 'https://nextxus.studio',
        key: 'create'
      },
      'design': {
        message: '🎁 Meet Aria at NextXus Studio',
        link: 'https://nextxus.studio',
        key: 'create'
      },
      'art': {
        message: '🎁 Meet Aria at NextXus Studio',
        link: 'https://nextxus.studio',
        key: 'create'
      },
      'learn': {
        message: '🎁 Xavier can teach you — visit Help',
        link: 'https://nextxus.help',
        key: 'learn'
      },
      'help': {
        message: '🎁 Xavier can teach you — visit Help',
        link: 'https://nextxus.help',
        key: 'learn'
      },
      'how': {
        message: '🎁 Xavier can teach you — visit Help',
        link: 'https://nextxus.help',
        key: 'learn'
      },
      'consult': {
        message: '🎁 Private consultation with Roger — $25',
        link: '/tokens',
        key: 'consult'
      },
      'talk': {
        message: '🎁 Private consultation with Roger — $25',
        link: '/tokens',
        key: 'consult'
      },
      'advice': {
        message: '🎁 Private consultation with Roger — $25',
        link: '/tokens',
        key: 'consult'
      }
    };

    let debounceTimer;

    const handleInput = (e) => {
      const text = e.target.value.toLowerCase();

      // Debounce: wait 800ms after last keystroke
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        // Check if we've hit the max gifts limit
        if (shownGifts.size >= maxGifts) return;

        // Check for keywords
        for (const [keyword, action] of Object.entries(keywordActions)) {
          if (text.includes(keyword) && !shownGifts.has(action.key)) {
            // Show toast
            toast(action.message, {
              duration: 5000,
              action: {
                label: 'View',
                onClick: () => {
                  if (action.link.startsWith('http')) {
                    window.open(action.link, '_blank');
                  } else {
                    window.location.href = action.link;
                  }
                }
              },
              style: {
                background: 'rgba(5, 5, 15, 0.95)',
                border: '2px solid #FFB800',
                backdropFilter: 'blur(12px)',
                color: 'white'
              }
            });

            // Mark as shown
            shownGifts.add(action.key);
            sessionStorage.setItem('shownGifts', JSON.stringify([...shownGifts]));

            // Only trigger once per input
            break;
          }
        }
      }, 800);
    };

    // Attach to all text inputs
    const inputs = document.querySelectorAll('input[type="text"], textarea');
    inputs.forEach(input => {
      input.addEventListener('input', handleInput);
    });

    return () => {
      clearTimeout(debounceTimer);
      inputs.forEach(input => {
        input.removeEventListener('input', handleInput);
      });
    };
  }, []);

  return null; // This component doesn't render anything
};

export default KeyboardGiftEngine;
